module.exports = __webpack_public_path__ + "static/media/freshworks-crm_logo.11050ece.svg";